import React, { useState } from 'react';
// reactstrap components
import {
    FormGroup,
    Input,
    Row,
    Col,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
} from "reactstrap";

const PaymentInformation = (props) => {
    const payment = props.payment
    const formDisabled = props.formDisabled

    return (
        <>
            <h6 className="heading-small text-muted mb-4">
                Payment information
            </h6>
            <div className="pl-lg-4">
                <Row>
                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-app"
                            >
                                App
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={payment?.subscription?.plan?.app?.name}
                                id="input-app"
                                name="app"
                                placeholder="App Name"
                                type="text"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-plan"
                            >
                                Plan
                            </label>
                            <Input
                                className="form-control-alternative"
                                defaultValue={payment?.subscription?.plan?.name}
                                id="input-plan"
                                name="plan"
                                placeholder="Plan Name"
                                type="text"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-licenses"
                            >
                                Licenses
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-licenses"
                                defaultValue={payment?.subscription?.licensesLimit}
                                type="number"
                                name="licensesLimit"
                                placeholder="Payment Licenses Limit"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>

                    <Col lg="6">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-periodicity"
                            >
                                Periodicity (Months)
                            </label>
                            <Input
                                className="form-control-alternative"
                                id="input-periodicity"
                                defaultValue={payment?.subscription?.plan?.periodicity}
                                type="number"
                                name="periodicity"
                                placeholder="Payment plan periodicity in Months"
                                disabled={formDisabled}
                            />
                        </FormGroup>
                    </Col>
                    
                </Row>

                <Row>
                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-price"
                            >
                                Price
                            </label>

                            <InputGroup id="input-group" className="input-group-alternative ">

                                <InputGroupAddon addonType="prepend" className=''>
                                    <InputGroupText >
                                        <i className="fas fa-dollar-sign trailing"></i>
                                    </InputGroupText>

                                    <Input
                                        className="form-control-alternative"
                                        id="input-price"
                                        defaultValue={payment?.itemPrice?.toFixed(2)}
                                        type="number"
                                        disabled={formDisabled}
                                        placeholder="Payment Price"
                                        name="price"
                                    />
                                </InputGroupAddon>

                            </InputGroup>

                        </FormGroup>
                    </Col>

                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-discount"
                            >
                                Discount
                            </label>

                            <InputGroup id="input-group" className="input-group-alternative ">

                                <InputGroupAddon addonType="prepend" className=''>
                                    <InputGroupText >
                                        <i className="fas fa-dollar-sign trailing"></i>
                                    </InputGroupText>

                                    <Input
                                        className="form-control-alternative"
                                        id="input-discount"
                                        defaultValue={payment?.discount?.toFixed(2)}
                                        type="number"
                                        disabled={formDisabled}
                                        placeholder="Payment Discount"
                                        name="discount"
                                    />
                                </InputGroupAddon>

                            </InputGroup>

                        </FormGroup>
                    </Col>

                    <Col lg="4">
                        <FormGroup>
                            <label
                                className="form-control-label"
                                htmlFor="input-total"
                            >
                                Total
                            </label>

                            <InputGroup id="input-group" className="input-group-alternative ">

                                <InputGroupAddon addonType="prepend" className=''>
                                    <InputGroupText >
                                        <i className="fas fa-dollar-sign trailing"></i>
                                    </InputGroupText>

                                    <Input
                                        className="form-control-alternative"
                                        id="input-total"
                                        defaultValue={payment?.total?.toFixed(2)}
                                        type="number"
                                        disabled={formDisabled}
                                        placeholder="Payment Total"
                                        name="total"
                                    />
                                </InputGroupAddon>

                            </InputGroup>

                        </FormGroup>
                    </Col>
                </Row>

            </div>
            
        </>
    )
}

export default PaymentInformation;